// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"0ca9d04bbd8d96d6","5216":"3ffd775a090f06d8"}[chunkId] + ".css";
};